import { useEffect, useState } from 'react';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import StripeService from '../../Services/http/StripeService';
import { loadStripe } from '@stripe/stripe-js';
import { useDispatch, useSelector } from 'react-redux';
import { setIsExistsInStripe } from '../../Redux/UserSlice';
import { Box, Button, FormControl, FormLabel, InputLabel, MenuItem, Select } from '@mui/material';
import StripeUtils from './StripeUtils';
import { setIsActiveSpinner } from '../../Redux/GeneralSlice';
import UsBankAccountForm from './UsBankAccountForm';
import { useParams } from 'react-router-dom';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { IconButton } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import userRoles from '../../configs/userRolesConfigs';
import { checkIsExistsUserInStripe, getUserAccountIdByAccountId } from '../Users/UsersUtils';


const NewPaymentMethod = ({ open, setOpen }) => {
    const [paymentMethod, setPaymentMethod] = useState('us_bank_account');
    const elements = useElements();
    const stripe = useStripe();
    const dispatch = useDispatch();
    const [userId, setUserId] = useState(null);
    const is_exists_in_stripe = useSelector((state: any) => state.user.is_exists_in_stripe);
    const userRole = useSelector((state: any) => state.general.userRol);
    const defaultAccount = useSelector(
        (state: any) => state.account.default_account
    );

    useEffect(() => {
        const getUserAccountIdByAccount = async () => {
            const user_id = await getUserAccountIdByAccountId(defaultAccount.id);
            setUserId(user_id);
            await checkIsExistsUserInStripe(dispatch, user_id);
        };
        
        if (userRole !== userRoles.account && defaultAccount && defaultAccount.id) {
            getUserAccountIdByAccount();
        } else {
            if (userRole === userRoles.account) {
                checkIsExistsUserInStripe(dispatch);
            }
        }
    }, [defaultAccount]);

    const onChangePaymentMethod = (event) => {
        setPaymentMethod(event.target.value);
    };

    const getClientSecretStripe = async (payment_method_type) => {
        const data = await StripeUtils.getClientSecret(payment_method_type, userId);
        if (data.success) {
            return data.client_secret;
        } else {
            alert("An error occurred geting client secret in stripe");
            dispatch(setIsActiveSpinner(false));
            return null;
        }
    };

    const createCustomerStripe = async () => {
        try {
            const data = await StripeUtils.createCustomer(userId);
            if (data.success) {
                dispatch(setIsExistsInStripe(true));
                return true;
            } else {
                alert("An error occurred creating a customer in stripe");
                return false;
            }
        } catch (error) {
            console.log('Error fetching create customer in stripe:', error);
            return false;
        }
    };

    const getClientSecret = async (payment_method_type) => {
        let client_secret_stripe;
        if (is_exists_in_stripe) {
            client_secret_stripe = await getClientSecretStripe(payment_method_type) as string;
        } else {
            const res = await createCustomerStripe();
            if (res) {
                client_secret_stripe = await getClientSecretStripe(payment_method_type) as string;
            }
        }
        return client_secret_stripe;
    };

    const saveNewCard = async (client_secret_stripe) => {
        const { error, setupIntent } = await stripe.confirmCardSetup(client_secret_stripe, {
            payment_method: { card: elements.getElement(CardElement) }
        });
        if (error) {
            console.error(error);
            alert("Error in adding payment method !!")
        } else {
            const res = await StripeUtils.updatePaymentMethodToDefault(
                dispatch, setupIntent.payment_method, userId
            );
            if (res) {
                elements.getElement(CardElement).clear(); // Clear the card element
                setOpen(false);
                alert("Successfully added payment method !!")
            }
            console.log('Setup intent succeeded:', setupIntent);
        }
    };

    const handleSubmit = async (event) => {
        try {
            event.preventDefault();
            dispatch(setIsActiveSpinner(true));
            let client_secret_stripe = await getClientSecret('card');
            if (!stripe || !elements) {
                return;
            }
            if (!client_secret_stripe) {
                return;
            }
            saveNewCard(client_secret_stripe);
            dispatch(setIsActiveSpinner(false));
        } catch {
            dispatch(setIsActiveSpinner(false));
        }
    };


    return (
        <>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="payment-method-dialog"
                className='payment-method-dialog'
            >
                <DialogTitle id="confirm-dialog" className='text-center'>
                    Add new payment method
                    <IconButton onClick={() => setOpen(false)} sx={{ float: 'right' }}>
                        <CloseOutlinedIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent style={{ minHeight: "300px" }}
                >
                    <Box sx={{ margin: 'auto', pb: 3 }}>
                        {/* <Grid item xs={12} sm={6} md={12} mb={1}> */}
                        <InputLabel id="demo-simple-select-label">
                            Payment Method Type*
                        </InputLabel>
                        <FormControl fullWidth sx={{ width: "350px", mb: 3 }}>
                            <Select
                                size='small'
                                name="role"
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={paymentMethod}
                                onChange={onChangePaymentMethod}
                                // onBlur={handleBlur}
                                variant="outlined"
                            >
                                <MenuItem value='us_bank_account'>US Bank Account</MenuItem>
                                <MenuItem value='card'>Card</MenuItem>
                            </Select>
                        </FormControl>
                        {/* </Grid> */}

                        {paymentMethod === 'card' &&
                            <form onSubmit={handleSubmit} style={{ width: '350px' }}>
                                <FormLabel sx={{ marginBottom: "20px" }}>
                                    Card details
                                    <Box sx={{ marginTop: "15px", marginBottom: "40px" }}>
                                        <div style={{
                                            border: '1px solid #ced4da',
                                            borderRadius: '4px', padding: '10px'
                                        }}>
                                            <CardElement options={{
                                                style: {
                                                    base: {
                                                        fontSize: '14px',
                                                        color: '#424770',
                                                        '::placeholder': {
                                                            color: '#aab7c4',
                                                        },
                                                    },
                                                    invalid: {
                                                        color: '#9e2146',
                                                    },
                                                },
                                                hidePostalCode: true, // Hide the postal code field
                                            }} />
                                        </div>
                                        <Box sx={{
                                            border: '1px solid #ced4da',
                                            borderRadius: '4px', padding: '3px',
                                            float: "right", fontSize: "12px", mt: 1
                                        }}>Powered by stripe</Box>
                                    </Box>

                                </FormLabel>
                                <Box sx={{ width: "350px" }}>
                                    <Button
                                        type="submit"
                                        variant="outlined"
                                        className="blue-btn"
                                        sx={{ marginTop: "15px", float: "right" }}
                                        disabled={!stripe}
                                    >
                                        Save
                                    </Button>

                                </Box>
                            </form>}
                        {paymentMethod === 'us_bank_account' &&
                            <UsBankAccountForm getClientSecret={getClientSecret} userId={userId} />
                        }
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    );
}
export default NewPaymentMethod;